export const TASKS_PER_BATCH = 20;
